<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Withdrawal Requests</h3>
      <!--<p class="sub-text fnt-14">Use the options below to fund your Smart Stewards wallet</p>-->
      </div>
    </div>
    <div class="content">
      <div v-if="pageLoading" class="text-center mt-5">
        <vue-loaders-ball-pulse color="red" scale=".75"></vue-loaders-ball-pulse>
        <p class="loadingText">Please wait</p>
      </div>
      <div v-else>
        <div>
          <div class="account_balance cabin-family">
            <p class="">Total Wallet Balance</p>
            <p class="bold">₦
              {{ Number(balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
            </p>
            <!-- <p class="balance cabin-family semi-bold">₦ 205,285.00</p> -->
          </div>
          <form>
            <div class="form-group">
              <label class="open-sans bold">Make Withdrawal Request</label>
              <input type="number" v-model="amount" placeholder="Amount" class="form-control"
              required>
            </div>
            <button class="btn primary-btn btn-block open-sans" :disabled="isDisabled"
            @click="addCooperative"><span v-if="!loading">Withdraw</span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader></button>
          </form>
          <h4>Withdrawal Requests</h4>
          <div class="transactions" v-if="transactions.length > 0">
            <div class="trans-table">
            <div class="trans-table-row" v-for="(trans, ind) in transactions.slice().reverse()"
            :key="ind">
            <div class="row2">
                <p>₦
                  {{ Number(trans.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </p>
                <div class="process-label" v-if="trans.status == 'requested'">In progress</div>
                <div class="success-label" v-else>Paid</div>
                <p></p>
              </div>
              <div class="row1">
                <p class="p1">{{ trans.createdAt | formatDate}}</p>
              </div>
            </div>
            </div>
          </div>
          <div class="empty-trans" v-else>
            <h4>You don't have any Withdrawal Request yet.</h4>
          </div>
        </div>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt">
    </success-component>
    <error-component v-if="showError" :message="errorMsg" @close="closePrompt"></error-component>
  </div>
</template>

<script>
import ErrorComponent from '../components/Error.vue';
import SuccessComponent from '../components/Success.vue';
import { withWalletTypeData, withWalletTypeParams } from '../utils/walletType';

export default {
  components: {
    ErrorComponent,
    SuccessComponent,
  },
  created() {
    this.getTransactions();
  },
  computed: {
    isDisabled() {
      if (this.amount < 1 || (this.balance < this.amount)) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      status: '',
      amount: 0,
      loading: false,
      pageLoading: true,
      showSuccess: false,
      showCoopLink: false,
      showError: false,
      showCoopPop: false,
      balance: 0,
      transactions: [],
    };
  },
  methods: {
    async addCooperative(e) {
      e.preventDefault();
      this.loading = true;
      try {
        const data = withWalletTypeData(this.$store, {
          amount: this.amount,
        });
        const url = `${this.$baseUrl}/request-withdrawal`;
        await this.$http({ url, data, method: 'POST' });
        this.amount = '';
        this.successMsg = 'Withdrawal Request created successfully, kindly wait for disbursement';
        this.getTransactions();
        this.showSuccess = true;
        this.loading = false;
      } catch (error) {
        this.errorMsg = error.response.data.message;
        this.showError = true;
        this.loading = false;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    },
    async getTransactions() {
      this.pageLoading = true;
      const params = withWalletTypeParams(this.$store);
      const url = `${this.$baseUrl}/withdrawal-requests`;
      const res = await this.$http({ url, method: 'GET', params });
      this.transactions = res.data.transactions;
      this.balance = res.data.balance || 0;
      this.pageLoading = false;
    },
    back() {
      this.$router.go(-1);
    },
    closePrompt() {
      this.showError = false;
      this.showSuccess = false;
      this.showCoopPop = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  a{
    color: #EE0E4C;
    font-weight: 400;
  }
  p {
    margin-bottom: .25rem;
  }
  .account_balance{
    margin: 0 0 1rem 0;
    background-color: #EE0E4C;
    color: #FFF;
    padding: 1rem;
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    border-radius: 8px;
  }
  .trans-table{
    padding: 1rem;
    border-radius: 8px;
    background-color: #FFF;
    &-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .75rem 0;
      border-bottom: 1px solid #E5E5E5;
      &:last-child{
        border-bottom: none;
      }
    }
    .row1{
      .p1{
        font-size: 11px;
        line-height: 12px;
        color: #49566A;
        font-family: 'Cabin', sans-serif;
      }
    }
    .row2{
      p{
        font-family: 'Cabin', sans-serif;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .transactions{
    margin-top: 1rem;
  }
  form{
    margin-bottom: 2rem;
  }
  .notification{
    text-align: center;
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 16px;
    // margin-top: 2rem;
    p{
      margin-bottom: 1rem;
    }
  }
  .loadingText{
    font-size: 20px;
  }
  .success-label{
    background-color: rgba($color: #50A948, $alpha: 0.2);
    color: #50A948;
    padding: .25rem;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
  }
  .process-label{
    background-color: #FFDDE6;
    color: #EE0E4C;
    padding: .25rem;
    border-radius: 8px;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
  }
  .empty-trans{
    margin-top: 2rem;
    text-align: center;
    color: #6b6b6b;
  }
</style>
